import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { appTitle } from "../common/GeneralConfigurations";
import TechnologyPageForm from "./TechnologyPageForm";
import {
  addTechnology,
  deleteTechnology,
  getTechnologies,
  updateTechnology,
} from "../../api/TechnologyApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";

const ManageTechnologyListPage = () => {
  const [loading, setLoading] = useState(false);
  const [technologyData, setTechnologyData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [event, setEvent] = useState("");
  const [technologyHandler, setTechnologyHandler] = useState({});

  useEffect(() => {
    document.title = `${appTitle} - Technology List`;
  }, []);

  useEffect(() => {
    getTechnologyData();
  }, []);
  const getTechnologyData = () => {
    getTechnologies().then((res) => {
      if (res.status == 200) {
        setTechnologyData(res.data.result);
        setLoading(false);
      } else {
        AdnMessageError("Failed to load data");
        setLoading(false);
      }
    });
  };
  const submitTechnology = (values) => {
    if (event == "add") {
      addTechnology(values).then((res) => {
        if (res.status == 201) {
          AdnMessageSuccess();
          getTechnologyData();
          setVisible(false);
        } else {
          AdnMessageError();
        }
      });
    } else if (event == "edit") {
      values.id = technologyHandler.id;
      updateTechnology(values).then((res) => {
        if (res.status == 200) {
          AdnMessageSuccess();
          getTechnologyData();
          setVisible(false);
        } else {
          AdnMessageError();
        }
      });
    }
  };
  const deleteRecord = (id) => {
    deleteTechnology(id).then((res) => {
      if (res.status == 200) {
        AdnMessageSuccess();
        getTechnologyData();
      } else {
        AdnMessageError();
      }
    });
  };
  return (
    <>
      <TechnologyPageForm
        loading={loading}
        technologyData={technologyData}
        visible={visible}
        setVisible={setVisible}
        event={event}
        submitTechnology={submitTechnology}
        setEvent={setEvent}
        deleteRecord={deleteRecord}
        setTechnologyHandler={setTechnologyHandler}
      />
    </>
  );
};

export default ManageTechnologyListPage;
